import { render, staticRenderFns } from "./NotesPanel.vue?vue&type=template&id=10c6af0a"
import script from "./NotesPanel.vue?vue&type=script&lang=js"
export * from "./NotesPanel.vue?vue&type=script&lang=js"
import style0 from "./NotesPanel.vue?vue&type=style&index=0&id=10c6af0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports